import React, { useContext } from 'react';
import { AlertDialog, Gender } from '../UI';
import { getAgeWithUnit, getFullDate } from '../../utils/dateTimeUtil';
import { Icon } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import useCheckMobileScreen from '../../hooks/useWidth';
import { Link, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import LanguageContext from '../../contexts/languageContext';
import { setSelectedPatient } from '../../redux/Patient/PatientAction';
import { useDispatch } from 'react-redux';
import { styles } from './patientItem.styles';
import useAddPatient from './AddPatient';
import MessagesContext from '../../contexts/messagesContext';
import useRoutes from '../../Routes/useRoutes';
const PatientItem = ({ patient, hasActiveLinks, handleOpenLinks }) => {
    const isMobile = useCheckMobileScreen();
    const { lang } = useContext(LanguageContext);
    const classes = styles({ hasActiveLinks, rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const { patientRoutes } = useRoutes();
    const dispatch = useDispatch();
    const { clinicId } = useParams();
    // const patients = useSelector((state) => state?.patient?.listOfPatients);

    const handlePatientItemAcordin = () => {
        handleOpenLinks(patient.id);
        dispatch(setSelectedPatient(patient));
    };
    const { dialog, setDialog, goToPatientPage } = useAddPatient(handlePatientItemAcordin);
    // const handleGoToPatientPage = () => {
    //     goToPatientPage(patient);
    // };
    return (
        <>
            <AlertDialog
                open={dialog}
                alertText={messages.alerts.warningNumberOfPatients}
                cancelText={messages.alerts.ok}
                handleClose={() => setDialog(false)}
                primaryCancelButton
            />
            <li
                key={patient.id}
                className={classes.patientRow}
                onClick={() => goToPatientPage(patient)}
                data-testid={'patientItem'}
            >
                <div className={classes.overall}>
                    {isMobile && <Icon component={ArrowBackIosIcon} />}
                    <Gender gender={patient.gender} height={'18'} />
                    <div className={classes.name}>
                        {patient.first_name} {patient.last_name}
                    </div>
                </div>
                <div className={classes.lastVisitDate}>
                    {patient.created ? getFullDate(patient.created) : '_'}
                </div>
                {/* <div className={classes.lastVisitTime}>
                    <span>{patient.last_admitted ? getDayOfWeek(patient.last_admitted) : '_'}</span>
                    <span>{patient.last_admitted && getTime(patient.last_admitted)}</span>
                </div> */}
                <div>
                    {patient.dob ? (
                        <div>
                            <span>{getAgeWithUnit(patient.dob).age}</span>{' '}
                            {getAgeWithUnit(patient.dob).unit}
                        </div>
                    ) : (
                        <span>–</span>
                    )}
                </div>
                <div>
                    <span>{patient.national_id}</span>
                </div>
                <div>
                    {patient.phone_number_1 ? (
                        <span>{patient.phone_number_1}</span>
                    ) : (
                        <span>–</span>
                    )}
                </div>
                <div className={classes.tagsContainer}>
                    {patient?.attending_clinics?.map((clinic) => (
                        <span className={classes.tag} key={clinic.id}>
                            {clinic.name}
                        </span>
                    ))}
                </div>
            </li>
            {hasActiveLinks && isMobile ? (
                <div className={classes.acordinWrapper}>
                    <>
                        {patientRoutes
                            .filter((link) => link.isMobile !== false)
                            .map((item, index) => (
                                <Link
                                    className={classes.acordinLink}
                                    key={index}
                                    to={`/${clinicId}/patient/${patient.id}/${item.name}`}
                                >
                                    <div className={classes.acordinRow}>
                                        {item.label}
                                        <Icon
                                            className={classes.arrowIconAcordin}
                                            component={ArrowBackIosIcon}
                                        />
                                    </div>
                                </Link>
                            ))}
                    </>
                </div>
            ) : null}
        </>
    );
};
PatientItem.propTypes = {
    patient: PropTypes.object,
    goToPatientPage: PropTypes.func,
    hasActiveLinks: PropTypes.bool,
    handleOpenLinks: PropTypes.func
};
export default PatientItem;
